import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeBrPrivModal } from '../../Store/Slices/brPrivSlice';
import AddBrPriv from './AddBrPriv';
import DeleteBrPriv from './DeleteBrPriv';
import EditBrPriv from './EditBrPriv';
import { useEffect } from 'react';
import { useState } from 'react';


const BrPrivDialog = () => {

    const dispatch = useDispatch();
    const brPriv = useSelector((state) => state.brPriv);
    const [roles, setRoles] = useState("")
  
    useEffect(() => {
      const getRoles = () => {
        if (typeof window !== undefined) {
          setRoles(sessionStorage.getItem("role"));
        }
      }
      getRoles()
    }, [])

    let content;
    let deleteView = false

    const handleClose = () => {
      dispatch(closeBrPrivModal(false))
    }

    if (brPriv.modalStatus === "add") {
      content = roles.split(",").includes("PRIV_ECOM_ADDMAPPING") && <AddBrPriv handleClose={() => handleClose()} />;
    } else if (brPriv.modalStatus === "edit") {
      content = roles.split(",").includes("PRIV_ECOM_EDITMAPPING") && <EditBrPriv handleClose={() => handleClose()} />;
    } else if (brPriv.modalStatus === "delete") {
      deleteView = true
      content = roles.split(",").includes("PRIV_ECOM_DELETEMAPPING") && <DeleteBrPriv/>;
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                sx={{
                  marginLeft: deleteView ? '25rem' : '18rem', 
                  marginRight: deleteView ? '25rem' : '18rem', 
                  maxWidth: deleteView ? 'fit-content' : 'none'
                }}
                open={brPriv.modalStatus === "add" || brPriv.modalStatus === "edit" || brPriv.modalStatus === "delete"}
            >
                <DialogContent>{content}</DialogContent>
            </Dialog>
        </>
    )
}

export default BrPrivDialog